(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  if (!window.lightboxLoaded) {
    var linkCss = document.createElement('link');
    linkCss.rel = 'stylesheet';
    linkCss.href = 'https://cdnjs.cloudflare.com/ajax/libs/lightbox2/2.11.3/css/lightbox.min.css';
    document.head.appendChild(linkCss);

    var script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/lightbox2/2.11.3/js/lightbox.min.js';
    document.body.appendChild(script);
    window.lightboxLoaded = true;
  }
});

  } catch(e) { console.error(e); }
})();
})();
